import { createSelector } from 'reselect';
import { get } from 'lodash/fp';
import { ApplicationState } from '@mews-commander/types';
import { TrackingConsent } from '@mews/enums';
import { TrackingConsents } from '@mews/framework';
import parentSelector from '../selector';
import { MODULE_NAME } from './module';

const moduleSelector = createSelector(parentSelector, get(MODULE_NAME));

const createConsentSelector = (consent: TrackingConsent) =>
    createSelector<ApplicationState, TrackingConsents, boolean>(moduleSelector, get(consent));

export const isFunctionalConsentGiven = createConsentSelector(TrackingConsent.Functional);
